<template>
  <b-container fluid class="v-card-ribbon">
    <b-row class="my-5 justify-content-center">
			<b-col cols="10">
        <b-card-group deck>
          <b-card
            v-for="(card, index) in cards" :key="index"
            align="center"
						no-body
          >
						<div class="flip-card" v-if="card.icon_back.data !== null">
							<div class="front">
								<b-card-img :src="iconSrc(card.icon_front)" alt="Image" :top=true></b-card-img>
								<b-card-body>
									<b-card-title>
										{{ card.title }}
									</b-card-title>
								</b-card-body>
							</div>
							<div class="back">
								<b-card-img :src="iconSrc(card.icon_back)" alt="Image" :top=true></b-card-img>
								<b-card-body>
									<b-card-text v-html="sanitizedContent(card.text)" />
								</b-card-body>
							</div>
						</div>
          </b-card>
        </b-card-group>
			</b-col>
		</b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    cards: Array
  },
	computed: {
		cols() {
			return 10 / this.cards.length
		}
	},
  methods: {
		iconSrc(icon) {
      return `/strapi/${icon.data.attributes.url}`
    },
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    },
		setCardClass() {
			
		}
  }
}
</script>

<style scoped src="@/assets/css/v-card-ribbon.css"/>
